import React from "react";
import { useTheme } from "../contexts/ThemeContext";

const Hero = () => {
  const { mode } = useTheme();

  return (
    <div
      className={`mt-4 p-6 rounded-lg shadow-lg transition-all duration-300 hover:shadow-xl 
      ${
        mode === "light"
          ? "bg-white text-gray-900"
          : "bg-gray-900 text-gray-200"
      }`}
    >
      <h3 className="text-4xl font-bold text-indigo-500">Manish Gupta</h3>
      <p className="text-lg text-gray-700">19yo Software Developer, IN/BLR</p>
      <h5 className="text-2xl font-semibold text-indigo-400">
        Freshman | Computer Science Enthusiast
      </h5>

      <p className="mt-4">
        Hi, I’m passionate about entrepreneurship and product building, with a
        keen interest in participating in hackathons. My favorite tools?
        <span className="font-bold text-indigo-500"> JavaScript</span> and
        <span className="font-bold text-indigo-500"> Python</span>! Let’s create
        something amazing together.
      </p>

      <hr className="my-4 border-gray-300" />

      <p>
        Feel free to reach me out at{" "}
        <a className="underline" href="https://x.com/firsegupta">
          x.com
        </a>{" "}
        or drop an email.
      </p>

      <a
        className="flex items-center mt-4 text-indigo-500 hover:text-indigo-700 transition-colors"
        href="https://linktr.ee/manish.react"
        target="_blank"
        rel="noopener noreferrer"
      >
        <p className="mr-1">Socials</p>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M15 12h6m0 0l-3 3m3-3l-3-3"
          />
        </svg>
      </a>
    </div>
  );
};

export default Hero;
